import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-modal-body',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './modal-body.component.html',
  styleUrl: './modal-body.component.scss'
})
export class ModalBodyComponent {

}
